import { AnnualReturn } from '../../models/annual-return';

export class GetAnnualReturns {
  static annualReturns: AnnualReturn[] = [
    {
      id: 1,
      organisationName: 'Medlog Portlink Pty Limited',
      reportingYear: 2025,
      reportingPeriodStart: '01/01/2025',
      reportingPeriodEnd: '31/12/2025',
      dueDate: '21/01/2026',
      submittedDate: null,
      status: 'In Progress',
      networkInterfaceCount: 2,
      networkInterfaceEffectiveDate: null,
      networkInterfaceReasonForChange: null,
      trackKm: [
        {
          stateTerritory: 'NSW',
          operationalTrackKm: 1.61,
          nonOperationalTrackKm: 0,
          totalTrackKm: 1.61,
        },
      ],
      networkInterfacesResponse: null,
      trackKmResponse: null,
      lineSectionsResponse: null,
      levelCrossingsResponse: null,
      definedLocationsResponse: null,
    },
    {
      id: 2,
      organisationName: 'Medlog Portlink Pty Limited',
      reportingYear: 2024,
      reportingPeriodStart: '01/01/2024',
      reportingPeriodEnd: '31/12/2024',
      dueDate: '21/01/2025',
      submittedDate: '15/01/2025',
      status: 'Submitted',
      networkInterfaceCount: 2,
      networkInterfaceEffectiveDate: '01/07/2024',
      networkInterfaceReasonForChange: 'Updated interface count after annual review.',
      trackKm: [
        {
          stateTerritory: 'NSW',
          operationalTrackKm: 1.61,
          nonOperationalTrackKm: 0,
          totalTrackKm: 1.61,
        },
      ],
      networkInterfacesResponse: 'correct',
      trackKmResponse: 'correct',
      lineSectionsResponse: 'correct',
      levelCrossingsResponse: 'correct',
      definedLocationsResponse: 'correct',
    },
  ];
}
